import { AdminBudgetRequests } from "@/components/AdminBudgetRequests";
import { AdminUsersManagement } from "@/components/AdminUsersManagement";
import { useLanguage } from "@/contexts/LanguageContext";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";

const Admin = () => {
  const { t } = useLanguage();
  
  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold mb-8">{t("admin.title")}</h1>
      
      <Tabs defaultValue="requests" className="w-full">
        <TabsList className="grid w-full md:w-[400px] grid-cols-2">
          <TabsTrigger value="requests">{t("admin.budgetRequests")}</TabsTrigger>
          <TabsTrigger value="users">{t("admin.usersManagement")}</TabsTrigger>
        </TabsList>
        
        <TabsContent value="requests" className="mt-6">
          <AdminBudgetRequests />
        </TabsContent>
        
        <TabsContent value="users" className="mt-6">
          <AdminUsersManagement />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default Admin;
